import { render } from "./SettingShift.vue?vue&type=template&id=54b56c8c&scoped=true"
import script from "./SettingShift.vue?vue&type=script&lang=js"
export * from "./SettingShift.vue?vue&type=script&lang=js"

import "./SettingShift.vue?vue&type=style&index=0&id=54b56c8c&scoped=true&lang=css"
import "./SettingShift.vue?vue&type=style&index=1&id=54b56c8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b56c8c"]])

export default __exports__